import { render, staticRenderFns } from "./UserSchedue.vue?vue&type=template&id=620f650a&scoped=true&"
import script from "./UserSchedue.vue?vue&type=script&lang=js&"
export * from "./UserSchedue.vue?vue&type=script&lang=js&"
import style0 from "./UserSchedue.vue?vue&type=style&index=0&id=620f650a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f650a",
  null
  
)

export default component.exports